var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenuCircle = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 16.875C28.864 16.875 30.375 15.364 30.375 13.5C30.375 11.636 28.864 10.125 27 10.125C25.136 10.125 23.625 11.636 23.625 13.5C23.625 15.364 25.136 16.875 27 16.875Z",
    fill: "#037782"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30.375C28.864 30.375 30.375 28.864 30.375 27C30.375 25.136 28.864 23.625 27 23.625C25.136 23.625 23.625 25.136 23.625 27C23.625 28.864 25.136 30.375 27 30.375Z",
    fill: "#037782"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 43.875C28.864 43.875 30.375 42.364 30.375 40.5C30.375 38.636 28.864 37.125 27 37.125C25.136 37.125 23.625 38.636 23.625 40.5C23.625 42.364 25.136 43.875 27 43.875Z",
    fill: "#037782"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenuCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/menuCircle.898f1de211dbf57528797fbd56717e6f.svg";